import { Navigation } from 'src/app/@theme/types/navigation';

export const menus: Navigation[] = [
  {
    id: 'home',
    title: 'Pagina Iniziale',
    type: 'item',
    url: '/',
   
  },
  {
    id: 'forms',
    title: 'Schede',
    type: 'item',
    icon: 'icon-navigation',
    ruolo:"MEDICO"
  },
  {
    id: 'lista_pazienti',
    title: 'Lista Pazienti',
    type: 'item',
    url: '/pazienti',
  }
  ,  {
    id: 'lista_richieste',
    title: 'Stati Processo',
    type: 'item',
    url: '/processi',
  },
  {
    id: 'farmacogenetica',
    title: 'Knowledge base',
    type: 'item',
    icon: 'icon-navigation',
   
  },
  {
    id: 'farmacogenetica',
    title: 'Farmacogenetica',
    type: 'item',
    icon: 'icon-navigation',
    url: '/farmaco-genetica',
    

  },
  {
    id: 'farmacogenetica',
    title: 'Ricerca per Molecola',
    type: 'item',
    icon: 'icon-navigation',
    url: '/principi-attivi',
    

  },
 {
    id: 'listaGeni',
    title: 'Ricerca Per Gene',
    type: 'item',
    icon: 'icon-navigation',
    url: '/lista-geni',
    

  }
];
